{
  "actions": {
    "save": "Enregistrer",
    "cancel": "Annuler",
    "delete": "Supprimer",
    "edit": "Modifier",
    "search": "Rechercher",
    "loading": "Chargement…",
    "yes": "Oui",
    "no": "Non",
    "close": "Fermer",
    "submit": "Soumettre",
    "back": "Retour",
    "next": "Suivant",
    "confirm": "Confirmer",
    "select": "Sélectionner…",
    "reset": "Réinitialiser",
    "ok": "OK",
    "export": "Exporter",
    "create": "Créer",
    "add": "Ajouter",
    "remove": "Retirer",
    "refresh": "Actualiser",
    "clear": "Effacer",
    "apply": "Appliquer",
    "view": "Voir",
    "download": "Télécharger",
    "upload": "Téléverser",
    "filter": "Filtrer",
    "more": "Plus",
    "update": "Mettre à jour",
    "activate": "Activer",
    "deactivate": "Désactiver",
    "clone": "Dupliquer",
    "schedule": "Planifier",
    "publish": "Publier",
    "submitForApproval": "Soumettre pour approbation",
    "send": "Envoyer",
    "start": "Démarrer",
    "assign": "Assigner",
    "archive": "Archiver",
    "reply": "Répondre",
    "lock": "Verrouiller",
    "reopen": "Rouvrir",
    "continue": "Continuer",
    "verify": "Vérifier",
    "goLive": "Mise en production",
    "use": "Utiliser",
    "selectItem": "Sélectionner",
    "addLine": "Ajouter une ligne",
    "connect": "Connecter",
    "reconnect": "Reconnecter",
    "disconnect": "Déconnecter",
    "configure": "Configurer"
  },
  "status": {
    "success": "Succès",
    "error": "Erreur",
    "warning": "Avertissement",
    "info": "Info"
  },
  "company": {
    "language": "Langue",
    "country": "Pays",
    "currency": "Devise",
    "timezone": "Fuseau horaire",
    "code": "Code",
    "name": "Nom",
    "default": "Par défaut",
    "label": "Société",
    "workingIn": "Vous travaillez dans {{name}}",
    "loading": "Chargement des sociétés…",
    "select": "Sélectionner une société"
  },
  "viewMode": {
    "list": "Liste",
    "calendar": "Calendrier",
    "hierarchy": "Hiérarchie",
    "label": "Mode d'affichage"
  },
  "table": {
    "search": "Rechercher…",
    "searchAria": "Rechercher dans le tableau",
    "noRecords": "Aucun enregistrement trouvé",
    "export": "Exporter",
    "pageOf": "Page {{page}} sur {{total}}",
    "totalCount": "{{count}} au total",
    "previousPage": "Page précédente",
    "nextPage": "Page suivante"
  },
  "dialog": {
    "confirm": "Confirmer",
    "cancel": "Annuler",
    "value": "Valeur"
  },
  "picker": {
    "selectDate": "Sélectionner une date",
    "selectTime": "Sélectionner l'heure",
    "selectDateTime": "Sélectionner date et heure",
    "hour": "Heure",
    "minute": "Minute",
    "from": "Du",
    "to": "Au",
    "selectDays": "Sélectionner les jours",
    "noDaysSelected": "Aucun jour sélectionné",
    "noMatches": "Aucun résultat",
    "search": "Rechercher…"
  },
  "layout": {
    "favorites": "Favoris",
    "recent": "Récents",
    "applications": "Vos applications",
    "products": "Vos produits",
    "pickWorkspace": "Choisissez un espace de travail",
    "enabledApps": "Applications activées pour votre organisation",
    "searching": "Recherche…",
    "noMatches": "Aucun résultat",
    "markAllRead": "Tout marquer comme lu",
    "clearAll": "Tout effacer",
    "clearing": "Effacement…",
    "noNotifications": "Aucune notification",
    "upgradeRequired": "Mettez à niveau votre abonnement pour débloquer",
    "upgradeTooltip": "{{label}} (mise à niveau requise)",
    "currentApp": "Application actuelle",
    "switchApp": "Changer d'application",
    "switchAppTooltip": "Changer d'application · {{label}}",
    "switchAppAria": "Changer d'application, actuelle : {{label}}",
    "switchApplication": "Changer d'application",
    "apps": "Applications"
  },
  "commandPalette": {
    "ariaLabel": "Rechercher",
    "placeholder": "Rechercher pages, clients, produits, prospects…",
    "close": "Fermer la recherche",
    "searching": "Recherche…",
    "noMatches": "Aucun résultat"
  },
  "form": {
    "field": "Champ",
    "value": "Valeur",
    "addField": "Ajouter un champ"
  },
  "toast": {
    "switchedToModule": "Basculé vers {{label}}"
  },
  "errors": {
    "failedToLoadCompanyOverview": "Échec du chargement de company overview",
    "youDoNotHaveAccessToThisApplication": "You do pas have access à ce application",
    "couldNotSwitchWorkspace": "Impossible de switch workspace",
    "failedToLoadRoles": "Échec du chargement de roles",
    "failedToLoadEmployees": "Échec du chargement de employees",
    "failedToLoadCustomers": "Échec du chargement de customers",
    "failedToLoadSuppliers": "Échec du chargement de suppliers",
    "failedToLoadProducts": "Échec du chargement de products",
    "failedToLoadProjects": "Échec du chargement de projects",
    "failedToLoadSocialAccounts": "Échec du chargement de social accounts",
    "failedToLoadWorkQueue": "Échec du chargement de work queue",
    "failedToLoadPurchaseOrders": "Échec du chargement de purchase orders",
    "failedToLoadPurchaseRequests": "Échec du chargement de purchase requests",
    "failedToLoadRfqs": "Échec du chargement de rFQs",
    "failedToLoadStores": "Échec du chargement de stores",
    "failedToChangePassword": "Échec de la modification du mot de passe",
    "couldNotLoadMfaStatus": "Impossible de charger l'état A2F",
    "couldNotStartMfaSetup": "Impossible de démarrer la configuration A2F",
    "invalidAuthenticatorCode": "Code d'authentification invalide",
    "couldNotSaveNotificationPreferences": "Impossible d'enregistrer les préférences de notification",
    "moduleNotEnabled": "Le module {{module}} n'est pas activé pour cette organisation",
    "loadListFailed": "Échec du chargement de list"
  },
  "access": {
    "pagePermissionDenied": "Vous n'avez pas la permission d'afficher cette page.",
    "pageNotAvailableForRole": "Cette page n'est pas disponible pour votre rôle.",
    "pageNotAvailableInModule": "Cette page n'est pas disponible dans votre module actuel.",
    "posTerminalPermissionDenied": "Vous n'avez pas la permission d'utiliser le terminal PDV.",
    "featureNotEnabled": "Fonctionnalité non activée : {{featureCode}}. Mettez à niveau votre abonnement pour débloquer."
  },
  "select": {
    "noProducts": "Aucun produit trouvé",
    "noEmployees": "Aucun employé trouvé",
    "noCustomers": "Aucun client trouvé",
    "noSuppliers": "Aucun fournisseur trouvé",
    "noStores": "Aucun magasin trouvé",
    "noProjects": "Aucun projet trouvé",
    "noCourses": "Aucune formation trouvée",
    "noShifts": "Aucun quart trouvé",
    "noDepartments": "Aucun département trouvé",
    "noDesignations": "Aucune désignation trouvée",
    "noGrades": "Aucun grade trouvé",
    "noBusinessUnits": "Aucune unité commerciale trouvée",
    "noPurchaseOrders": "Aucun bon de commande trouvé",
    "noPurchaseRequests": "Aucune demande d'achat trouvée",
    "noRfqs": "Aucune demande de prix trouvée",
    "noLeaveTypes": "Aucun type de congé — configurez-les dans les données de base RH",
    "noShiftTypes": "Aucun type de quart — configurez-les dans les données de base RH",
    "noEmploymentTypes": "Aucun type d'emploi — configurez-les dans les données de base RH",
    "noExpenseTypes": "Aucun type de dépense — configurez-les dans les données de base RH",
    "noDocumentTypes": "Aucun type de document — configurez-les dans les données de base RH",
    "noOvertimeTypes": "Aucun type d'heures supplémentaires — les valeurs par défaut sont créées automatiquement",
    "searchProduct": "Rechercher un produit par nom ou SKU…",
    "searchProductDetail": "Rechercher par nom, SKU ou code-barres…",
    "none": "Aucun",
    "noManager": "Aucun responsable",
    "selectEmployee": "Sélectionner un employé",
    "selectCustomer": "Sélectionner un client",
    "selectSupplier": "Sélectionner un fournisseur",
    "selectSuppliers": "Rechercher et sélectionner des fournisseurs…",
    "selectLeaveType": "Sélectionner un type de congé",
    "selectPurchaseRequestOptional": "Sélectionner une demande d'achat (facultatif)",
    "selectEmployees": "Sélectionner des employés…",
    "selectProject": "Sélectionner un projet",
    "searchPurchaseOrder": "Rechercher un bon de commande…",
    "selectManager": "Sélectionner un responsable",
    "selectEmploymentType": "Sélectionner un type d'emploi",
    "selectShiftType": "Sélectionner un type de quart",
    "selectDepartment": "Sélectionner un département",
    "selectDesignation": "Sélectionner une désignation",
    "selectGrade": "Sélectionner un grade",
    "selectBusinessUnit": "Sélectionner une unité commerciale",
    "selectExpenseType": "Sélectionner un type de dépense",
    "selectDocumentType": "Sélectionner un type de document",
    "selectShift": "Sélectionner un quart",
    "selectStore": "Sélectionner un magasin",
    "selectCourse": "Sélectionner une formation",
    "searchRfq": "Rechercher une demande de prix…",
    "selectOvertimeType": "Sélectionner un type d'heures supplémentaires",
    "selectProduct": "Sélectionner un produit",
    "selectCountry": "Sélectionner un pays",
    "selectCurrency": "Sélectionner une devise",
    "selectTimezone": "Sélectionner un fuseau horaire",
    "selectLanguage": "Sélectionner une langue",
    "searchAndSelectEmployees": "Rechercher et sélectionner des employés…",
    "searchEmployee": "Rechercher par code, nom ou e-mail…",
    "searchEmploymentTypes": "Rechercher des types d'emploi…",
    "searchShiftTypes": "Rechercher des types de quart…",
    "searchDepartments": "Rechercher des départements…",
    "searchDesignations": "Rechercher des désignations…",
    "searchGrades": "Rechercher des grades…",
    "searchBusinessUnits": "Rechercher des unités commerciales…",
    "searchLeaveTypes": "Rechercher des types de congé…",
    "searchCustomers": "Rechercher des clients…",
    "searchOvertimeTypes": "Rechercher des types d'heures supplémentaires…",
    "searchSuppliers": "Rechercher des fournisseurs…",
    "searchSuppliersDetail": "Rechercher par nom, e-mail ou n° TVA…",
    "searchPoNumber": "Rechercher par n° de bon de commande…",
    "searchProjects": "Rechercher des projets…",
    "searchRequestNumber": "Rechercher par n° de demande…",
    "searchShifts": "Rechercher des quarts…",
    "searchCourses": "Rechercher des formations…",
    "searchDocumentTypes": "Rechercher des types de document…",
    "searchStores": "Rechercher par nom ou code de magasin…",
    "searchRfqNumber": "Rechercher par n° de demande de prix…",
    "searchCountries": "Rechercher des pays…",
    "searchCurrencies": "Rechercher des devises…",
    "searchTimezones": "Rechercher des fuseaux horaires…",
    "searchLanguages": "Rechercher des langues…",
    "searchExpenseTypes": "Rechercher des types de dépense…",
    "searchProductBarcode": "Rechercher par nom, SKU ou scanner un code-barres…",
    "searchBills": "Rechercher des factures…",
    "searchMasterAdmins": "Rechercher des administrateurs maîtres…",
    "searchEmailName": "Rechercher par e-mail, nom…",
    "loadingStores": "Chargement des magasins…",
    "noCountries": "Aucun pays trouvé",
    "noCurrencies": "Aucune devise trouvée",
    "noTimezones": "Aucun fuseau horaire trouvé",
    "noLanguages": "Aucune langue trouvée"
  },
  "placeholders": {
    "all": "Tous",
    "name": "Nom",
    "code": "Code",
    "email": "E-mail",
    "port": "Port",
    "amount": "Montant",
    "value": "Valeur",
    "any": "Tous",
    "reply": "Répondre…",
    "addTag": "Ajouter une étiquette",
    "noFileChosen": "Aucun fichier sélectionné",
    "chooseFile": "Choisir un fichier",
    "eG1": "p. ex. 1",
    "eG10": "p. ex. 10",
    "eG50": "p. ex. 50",
    "eG100": "p. ex. 100",
    "percentRange": "0–100",
    "loading": "Chargement…",
    "dash": "—",
    "weightUnit": "Poids ({{unit}})"
  },
  "preferences": {
    "appearance": "Apparence",
    "appearanceDesc": "Basculez entre le mode clair et sombre. Votre choix est enregistré sur cet appareil.",
    "light": "Clair",
    "dark": "Sombre",
    "sampleGuides": "Guides d'exemple",
    "sampleGuidesDesc": "Parcourez des exemples pour découvrir chaque module — aucune donnée de production n'est modifiée."
  },
  "security": {
    "twoFactorTitle": "Authentification à deux facteurs",
    "twoFactorDesc": "Ajoutez une couche de protection supplémentaire lors de la connexion.",
    "passwordTitle": "Mot de passe",
    "passwordDesc": "Utilisez un mot de passe fort d'au moins 8 caractères.",
    "updatePassword": "Mettre à jour le mot de passe",
    "required": "Obligatoire",
    "passwordMin8": "Au moins 8 caractères",
    "passwordsMismatch": "Les mots de passe doivent correspondre",
    "loadingSettings": "Chargement des paramètres de sécurité…",
    "mfaProtectDesc": "Protégez votre compte avec un code à 6 chiffres depuis Google Authenticator, Microsoft Authenticator ou une application similaire.",
    "enabled": "Activée",
    "disabled": "Désactivée",
    "mfaSignInPrompt": "Un code d'authentification vous sera demandé à chaque connexion.",
    "disableMfa": "Désactiver l'authentification à deux facteurs",
    "enableMfa": "Activer l'authentification à deux facteurs",
    "confirmAndEnable": "Confirmer et activer",
    "setupSteps": "Étapes de configuration",
    "setupStep1": "Ouvrez votre application d'authentification.",
    "setupStep2": "Scannez le code QR ou saisissez le secret manuellement.",
    "setupStep3": "Saisissez le code à 6 chiffres ci-dessous pour confirmer.",
    "mfaQrAlt": "Code QR A2F",
    "scanQrCode": "Scannez le code QR avec votre application d'authentification"
  },
  "notifications": {
    "title": "Préférences de notification",
    "description": "Contrôlez les alertes dans l'application et par e-mail pour les applications auxquelles vous avez accès. Les approbations s'appliquent à l'ensemble de vos flux de travail. Toutes les options sont activées par défaut. Les e-mails de sécurité tels que la réinitialisation du mot de passe sont toujours envoyés.",
    "saving": "Enregistrement…",
    "saved": "Enregistré",
    "emptyCategories": "Aucune catégorie de notification n'est disponible pour votre compte pour le moment."
  },
  "profileMenu": {
    "myProfile": "Mon profil",
    "signOut": "Se déconnecter"
  },
  "pages": {
    "stores": "Magasins",
    "warehouses": "Entrepôts",
    "headcount": "Headcount",
    "pendingLeave": "Pending congé",
    "openCrmDeals": "Open CRM deals",
    "openCrmLeads": "Open CRM leads",
    "deskTickets": "Desk tickets",
    "openPos": "Open POs",
    "financeAccounts": "Finance accounts",
    "monthStoreSales": "Month magasin sales",
    "monthInvoices": "Month factures",
    "payrollRuns": "Paie runs",
    "accessDenied": "Accès refusé",
    "pageNotFound": "Page introuvable",
    "sampleDataGuidedSetup": "Sample data & guided setup",
    "general": "Général",
    "yourApplications": "Vos applications",
    "approvalsSystemUpdatesAndStockAlerts": "Approbations, mises à jour système et alertes de stock pertinentes pour vos applications.",
    "alertsForTheModulesEnabledFor": "Alertes pour les modules activés pour votre rôle."
  },
  "dashboard": {
    "keyMetrics": "Indicateurs clés",
    "metrics": "Indicateurs",
    "period": {
      "day": "Aujourd'hui",
      "month": "Ce mois-ci",
      "year": "Cette année"
    },
    "trends": {
      "yearWeek": "Semaine {{label}}",
      "total": "Total"
    },
    "companyOverview": {
      "selectCompany": "Sélectionnez une entreprise dans l'en-tête pour voir les KPI à l'échelle de l'entreprise (RH, CRM, support, achats et finance).",
      "description": "Vue d'ensemble · {{currencyCode}}{{departmentNote}}",
      "departmentLimited": " · limité à {{count}} service(s)"
    },
    "widgets": {
      "hr-headcount": "Effectifs",
      "hr-pending-leaves": "Congés en attente",
      "hr-attendance-today": "Présence aujourd'hui",
      "hr-approvals": "Approbations en attente",
      "pos-sales-today": "Ventes du jour",
      "pos-invoices": "Factures",
      "pos-low-stock": "Alertes stock bas",
      "fin-receivables": "Créances",
      "fin-payables": "Dettes",
      "fin-cashflow": "Solde de trésorerie",
      "proc-open-pr": "DA ouvertes",
      "proc-pending-po": "BC en attente",
      "crm-pipeline": "Valeur du pipeline",
      "crm-leads": "Nouveaux prospects",
      "wh-open-picks": "Prélèvements ouverts",
      "wh-transfers": "Transferts",
      "wh-cycle-counts": "Inventaires tournants",
      "desk-open-tickets": "Tickets ouverts",
      "desk-sla-breach": "Dépassements SLA",
      "proj-active": "Projets actifs",
      "proj-overdue": "Tâches en retard",
      "mkt-campaigns": "Campagnes",
      "mkt-sent": "E-mails envoyés",
      "soc-inbox": "Boîte de réception",
      "soc-scheduled": "Publications planifiées",
      "lg-leads": "Nouveaux prospects",
      "lg-forms": "Formulaires actifs",
      "org-summary": "Résumé de l'organisation",
      "org-notifications": "Notifications"
    }
  },
  "labels": {
    "user": "User",
    "selectEmployeeWithLogin": "Select employé avec login…",
    "addUser": "Add utiliserr",
    "selectEmployeeWithLogin2": "Select employé avec login",
    "dashboardPeriod": "Tableau de bord period",
    "newPassword": "New password",
    "confirmPassword": "Confirm password",
    "copyPassword": "Copy password",
    "removeLine": "Remove line",
    "toggleSidebar": "Toggle sidebar",
    "searchCtrlK": "Search (Ctrl+K)",
    "closeNotifications": "Close notifications",
    "accountMenu": "Menu du compte",
    "workspaceNavigation": "Workspace navigation",
    "clearSelection": "Clear sélectionnerion",
    "searchScreens": "Search screens",
    "screenNameOrRoute": "Screen name ou route",
    "authenticatorCode": "Authenticator code",
    "verificationCode": "Verification code",
    "enterCodeToDisableMfa": "Saisissez code to disable MFA",
    "actionSettings": "Action paramètres",
    "calendar": "Calendar",
    "previousMonth": "Previous month",
    "nextMonth": "Next month",
    "hour": "Hour",
    "minute": "Minute",
    "removeFile": "Remove file",
    "field": "Field",
    "fieldName": "Field name",
    "value": "Value",
    "customFieldName": "Custom field name",
    "selectField": "Select field",
    "eGCountry": "e.g. country",
    "eGProductcode": "e.g. produitCode",
    "closeDialog": "Close dialog",
    "selectCountry": "Select country",
    "searchCountryOrCode": "Search country ou code…",
    "clearAllSelections": "Clear all sélectionnerions",
    "loadingTable": "Loading table",
    "loadingPage": "Loading page",
    "loadingDashboard": "Loading tableau de bord",
    "inApp": "Dans l'application",
    "email": "E-mail",
    "theme": "Theme",
    "currentPassword": "Current password",
    "confirmNewPassword": "Confirm new password",
    "dismissNotification": "Dismiss notification",
    "expandQuickStartChecklist": "Expand quick start checklist",
    "quickStartChecklist": "Quick start checklist",
    "minimizeQuickStart": "Minimize quick start",
    "dismissQuickStart": "Dismiss quick start"
  },
  "columns": {
    "code": "Code",
    "name": "Nom",
    "status": "Statut",
    "actions": "Actions",
    "description": "Description",
    "color": "Couleur",
    "employee": "Employé",
    "shift": "Quart",
    "hours": "Heures",
    "days": "Jours",
    "type": "Type",
    "date": "Date",
    "title": "Titre",
    "category": "Catégorie",
    "provider": "Fournisseur",
    "active": "Actif",
    "location": "Lieu",
    "email": "E-mail",
    "role": "Rôle",
    "amount": "Montant",
    "comments": "Commentaires",
    "level": "Niveau",
    "grade": "Grade",
    "start": "Début",
    "end": "Fin",
    "score": "Score",
    "reason": "Motif",
    "content": "Contenu",
    "rating": "Note",
    "reviewer": "Évaluateur",
    "cycle": "Cycle",
    "details": "Détails",
    "expiry": "Expiration",
    "download": "Télécharger",
    "claim": "Note de frais",
    "from": "Du",
    "to": "Au",
    "run": "Paie",
    "gross": "Brut",
    "net": "Net",
    "product": "Produit",
    "revenue": "Revenu",
    "payment": "Paiement",
    "invoiceNumber": "Facture n°",
    "quantitySold": "Qté vendue",
    "rate": "Taux %",
    "taxable": "Imposable",
    "tax": "Taxe",
    "lines": "Lignes",
    "alertQty": "Qté alerte",
    "need": "Besoin",
    "daysLeft": "Jours restants",
    "invoices": "Factures",
    "sales": "Ventes",
    "organization": "Organisation",
    "platforms": "Plateformes",
    "paid": "Payé",
    "carryForward": "Report",
    "payrollMode": "Mode de paie",
    "hoursPerDay": "Heures/jour",
    "endDateRequired": "Date de fin requise",
    "trackExpiry": "Suivre l'expiration",
    "receiptRequired": "Reçu requis",
    "leaveType": "Type de congé",
    "policy": "Politique",
    "annualDays": "Jours annuels",
    "accrual": "Acquisition",
    "maxConsecutive": "Max consécutif",
    "carryForwardMax": "Report max",
    "backdated": "Antidaté",
    "nonWorking": "Non ouvré",
    "workingDays": "Jours ouvrés",
    "defaultHours": "Heures par défaut",
    "employment": "Emploi",
    "headcount": "Effectif",
    "positions": "Postes",
    "position": "Poste",
    "relationship": "Relation",
    "grossAmount": "Montant brut",
    "effectiveFrom": "En vigueur à partir du",
    "effectiveTo": "En vigueur jusqu'au",
    "salaryStructure": "Structure salariale",
    "structureName": "Nom de structure",
    "applicableDay": "Jour applicable",
    "netAmount": "Montant net",
    "employeeId": "ID employé",
    "deductions": "Déductions",
    "mode": "Mode",
    "inOut": "Entrée / sortie",
    "open": "Ouvert",
    "ot": "HS",
    "worked": "Travaillé",
    "week": "Semaine",
    "course": "Formation",
    "tag": "Étiquette"
  }
}
